export default __webpack_public_path__ + "images/RL.e65193f.png";